import { render, staticRenderFns } from "./RecommendedIngredientsList.vue?vue&type=template&id=5207c0d6&scoped=true"
import script from "./RecommendedIngredientsList.vue?vue&type=script&lang=js"
export * from "./RecommendedIngredientsList.vue?vue&type=script&lang=js"
import style0 from "./RecommendedIngredientsList.vue?vue&type=style&index=0&id=5207c0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207c0d6",
  null
  
)

export default component.exports